// extracted by mini-css-extract-plugin
module.exports = {"adminFeeInfoButton":"admin-fee-button_adminFeeInfoButton__wEL6L"};